// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"a235a342","291":"e7b62367","611":"bec3f4d8","687":"0a743caa","738":"21722032","891":"9b7c59d6","941":"5985353b","948":"f4c5a45a","996":"a823609b"}[chunkId] + ".chunk.js";
};